

<app-bread-crumb [Locations]="[{target : 'home', label : 'Home'}]" current="Your favourites">
</app-bread-crumb>

<app-hero-banner title="Your favourites"></app-hero-banner>


<section class="nsw-section">
	<div class="nsw-container">	
		<ng-container *ngIf="!favouriteSitesDetails?.length">					
			<p>		
				<strong>You have no favourite swim sites.</strong>
				<br/><br/>			
				You can add a favourite swim site by clicking on 'Add to favourites' or the heart on the swim site page. 
			</p>
		</ng-container>
		
		<ng-container *ngFor="let items of favouriteSitesDetails; let i = index">
			<div class="nsw-grid nsw-grid--spaced">
				<div class="nsw-col">
					<div class="nsw-grid nsw-grid--spaced">
						<ng-container *ngFor="let item of items; let j = index">	
							<div class="nsw-col nsw-col-xl-4 nsw-col-md-6 nsw-col-sm-12">
								<div class="nsw-content-block nsw-m-right-sm">
									<div style="display : flex; flex-direction : column; align-items : center;">
										<app-favourite-site *ngIf="item?.Identifier" [siteDetails]="item"
											(removeFromFavourites)="onRemoveFromFavourites($event)">
										</app-favourite-site>
									</div>
								</div>
							</div>					
						</ng-container>
					</div>			
				</div>
			</div>
		</ng-container>
	</div>
</section>
